export const OTP_SIZE = 6;
export const SMS_ATTEMPT_TIMEOUT_SECONDS = 30 as const;
export const SMS_ATTEMPT_TIMEOUT_MILLISECONDS = SMS_ATTEMPT_TIMEOUT_SECONDS * 1000;
export const OC_CUSTOMER_BLOCKED_ERROR = 'OC_CUSTOMER_BLOCKED_ERROR';
export const OC_CUSTOMER_PHONE_NUMBER_INACTIVE_ERROR = 'OC_CUSTOMER_PHONE_NUMBER_INACTIVE_ERROR';
export const OC_MEMBERSHIP_DELETED_ERROR = 'OC_MEMBERSHIP_DELETED_ERROR';
